/**
 * State emails (#635): members whose CE21 email is made up (a `first.last@chiromi.com` placeholder) or empty, beside
 * the address the latest state list has for them. Tim types it into CE21 by hand; Keystone writes neither address
 * anywhere. Reached from the Licences view's line and ⌘K. No Copy emails: CE21's addresses here are made up, and the
 * state's are not to be copied past the opt-out gate. Export CSV carries both, opt-outs left out (`exports.ts`).
 */
import type { PersonLine, ViewDef } from "../views";

export const STATE_EMAILS: ViewDef = {
  id: "state-emails",
  title: "State emails",
  paged: false,
  emails: "none",
  columns: [
    { key: "standing", label: "Standing", kind: "standing" },
    { key: "ce21", label: "CE21 email" },
    { key: "state", label: "State email", wide: true },
  ],
  empty: "No made-up CE21 email has a state email.",
  facts: (rows: PersonLine[]) => [[rows.filter((r) => r.tag === "empty").length, "with no CE21 email"]],
};
